

























import { Vue, Component, Prop } from 'vue-property-decorator';
import { NotificationSettingsInterface } from "../../../api/models/interfaces/Settings/NotificationSettingsInterface";

enum notificationOptions {
    never = 'never',
    periodically = 'periodically',
    immediately = 'immediately'
}

@Component({
    name: 'NotificationsSwitcher'
})
export default class NotificationsSwitcher extends Vue {
    @Prop() value: NotificationSettingsInterface;
    settings: NotificationSettingsInterface | null = null;

    created() {
        this.settings = {
            email: {
                meetings: this.value?.email?.meetings ?? true,
                comments: this.value?.email?.comments ?? true,
                meetingsInvitationsDigest: this.value?.email?.meetingsInvitationsDigest ?? true
            }
        }
    }

    get meetings() {
        if (this.settings?.email.meetings && this.settings?.email.meetingsInvitationsDigest) {
            return notificationOptions.periodically;
        } else if (this.settings?.email.meetings && !this.settings?.email.meetingsInvitationsDigest) {
            return notificationOptions.immediately
        } else {
            return notificationOptions.never;
        }
    }

    set meetings(value: notificationOptions) {
        if (!this.settings) { return; }

        switch (value) {
            case notificationOptions.periodically:
                this.settings.email.meetings = true;
                this.settings.email.meetingsInvitationsDigest = true;
                break;
            case notificationOptions.immediately:
                this.settings.email.meetings = true;
                this.settings.email.meetingsInvitationsDigest = false;
                break;
            default: 
                this.settings.email.meetings = false;
                this.settings.email.meetingsInvitationsDigest = false;
        }

        this.onChanged();
    }

    get comments() {
        if (this.settings?.email.comments) {
            return notificationOptions.immediately;
        } else {
            return notificationOptions.never;
        }
    }

    set comments(value: notificationOptions) {
        if (!this.settings) { return; }

        switch (value) {
            case notificationOptions.immediately:
                this.settings.email.comments = true;
                break;
            default: 
                this.settings.email.comments = false;
        }

        this.onChanged();
    }

    async onChanged() {
        this.$emit('input', this.settings);
    }
}
